import { type FC, useEffect, useRef } from "react";
import { DefinitionList } from "@root/shared/components/DefinitionList";
import { useReadMoreButtonHeight } from "@root/shared/components/ReadMoreButton/useReadMoreButtonHeight";
import * as styles from "./styles.css";

type Props = {
  userSchoolInfoList: { term: string; description: string | string[] }[][];
};

export const UserSchoolsDefinitionList: FC<Props> = ({ userSchoolInfoList }) => {
  const setContainerHeight = useReadMoreButtonHeight();
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (elementRef.current && setContainerHeight) {
      // ボタンを表示する高さは１つ目の要素の高さ
      setContainerHeight(elementRef.current.clientHeight);
    }
  }, [setContainerHeight]);

  return (
    <>
      {userSchoolInfoList.map((userSchoolInfoListItems, index) => (
        <DefinitionList
          // eslint-disable-next-line react/no-array-index-key
          key={`${userSchoolInfoListItems[0].term}_${index}`}
          title={`学歴${index + 1}`}
          items={userSchoolInfoListItems}
          className={styles.definitionListContainer}
          elementRef={index === 0 ? elementRef : null}
        />
      ))}
    </>
  );
};
